import React, { Component } from 'react';
import { ajaxWrapper, format_date } from 'functions';

import {
    Loading,
    Container,
    Header,
    FormWithChildren,
    Select,
    TextAutocomplete,
    Table,
    TableRow,
    TableHeader,
    DateTimePicker,
    Alert,
    StickyCorner,
    Button,
} from 'library';

import Navbar from 'projectLibrary/navbar.js';

function get_headers_by_day(state) {
    let date_headers = [];
    let empty_cells = [];

    let start_date = new Date(Date.parse(state.start_date));
    let end_date = new Date(Date.parse(state.end_date));

    while (start_date <= end_date) {
        let date_string = format_date(start_date, 'mm/dd');

        date_headers.push(
            <th className="sticky-row">
                <div
                    style={{
                        fontSize: '12px',
                        textAlign: 'center',
                    }}
                >
                    {date_string}
                </div>
            </th>,
        );
        empty_cells.push(<td className="empty-cell"></td>);

        start_date.setDate(start_date.getDate() + 1);
    }

    return [date_headers, empty_cells];
}

function get_headers_by_week(state) {
    let date_headers = [];
    let empty_cells = [];

    let start_date = new Date(Date.parse(state.start_date));
    let end_date = new Date(Date.parse(state.end_date));

    let start_date_string = format_date(start_date, 'mm/dd');

    while (start_date <= end_date) {
        start_date.setDate(start_date.getDate() + 1);

        if (start_date.getDay() == 5) {
            date_headers.push(
                <th className="sticky-row">
                    <div
                        style={{
                            fontSize: '12px',
                            textAlign: 'center',
                        }}
                    >
                        {`${start_date_string} - ${format_date(start_date, 'mm/dd')}`}
                    </div>
                </th>,
            );

            empty_cells.push(<td className="empty-cell"></td>);

            start_date.setDate(start_date.getDate() + 1);
            start_date_string = format_date(start_date, 'mm/dd');
        }
    }

    return [date_headers, empty_cells];
}

function get_submission_cells_by_day(state, process_name, search_value) {
    let total_submissions = 0;

    let cells = [];
    let has_submissions =
        search_value['name'] in state.submissions[process_name];

    let start_date = new Date(Date.parse(state.start_date));
    let end_date = new Date(Date.parse(state.end_date));
    while (start_date <= end_date) {
        let working_date = format_date(start_date, 'mm/dd/yyyy');
        if (
            has_submissions &&
            working_date in
                state.submissions[process_name][search_value['name']] &&
            state.submissions[process_name][search_value['name']][working_date][
                'result'
            ]
        ) {
            cells.push(
                <td
                    style={{
                        background: '#fcfcfc',
                    }}
                >
                    <div
                        style={{
                            fontSize: '12px',
                            textAlign: 'center',
                        }}
                    >
                        <a
                            style={{ textDecoration: 'none' }}
                            target={'_blank'}
                            href={`/process/${
                                state.submissions[process_name][
                                    search_value['name']
                                ][working_date]['process_id']
                            }/review/?search_value=${search_value['name']}&double_value=${working_date}`}
                        >
                            {
                                state.submissions[process_name][
                                    search_value['name']
                                ][working_date]['result']
                            }
                        </a>
                    </div>
                </td>,
            );

            total_submissions += 1;
        } else {
            cells.push(<td style={{ background: '#fcfcfc' }}></td>);
        }

        start_date.setDate(start_date.getDate() + 1);
    }

    return [cells, total_submissions];
}

function get_submission_cells_by_week(state, process_name, search_value) {
    let total_by_weeks = [];

    let cells = [];
    let has_submissions =
        search_value['name'] in state.submissions[process_name];

    let start_date = new Date(Date.parse(state.start_date));
    let end_date = new Date(Date.parse(state.end_date));
    while (start_date <= end_date) {
        let total_by_week = 0;

        let working_dates = [];
        for (let days of [0, 1, 2, 3, 4, 5, 6]) {
            let after_start_date = new Date(start_date);
            after_start_date.setDate(start_date.getDate() + days);

            working_dates.push(format_date(after_start_date, 'mm/dd/yyyy'));
        }

        let submission_dates = Object.keys(
            has_submissions
                ? state.submissions[process_name][search_value['name']]
                : {},
        );
        let matched_dates = working_dates.filter((value) =>
            submission_dates.includes(value),
        );

        let found = false;
        if (has_submissions && matched_dates.length > 0) {
            for (let date of matched_dates) {
                if (
                    !state.submissions[process_name][search_value['name']][
                        date
                    ]['result']
                ) {
                    continue;
                }

                cells.push(
                    <td
                        style={{
                            background: '#fcfcfc',
                        }}
                    >
                        <div
                            style={{
                                fontSize: '12px',
                                textAlign: 'center',
                            }}
                        >
                            <a
                                style={{ textDecoration: 'none' }}
                                target={'_blank'}
                                href={`/process/${
                                    state.submissions[process_name][
                                        search_value['name']
                                    ][date]['process_id']
                                }/review/?search_value=${search_value['name']}&double_value=${date}`}
                            >
                                {
                                    state.submissions[process_name][
                                        search_value['name']
                                    ][date]['result']
                                }
                            </a>
                        </div>
                    </td>,
                );

                found = true;
                total_by_week += 1;
                break;
            }
        }

        if (!found) {
            cells.push(<td style={{ background: '#fcfcfc' }}></td>);
        }

        total_by_weeks.push(total_by_week);
        total_by_week = 0;
        start_date.setDate(start_date.getDate() + 7);
    }

    return [cells, total_by_weeks];
}

function downloadHTMLTableAsCSV(tableId, filename = 'export.csv') {
    const table = document.getElementById(tableId);
    const rows = table.querySelectorAll('tr');
    const csvData = [];

    for (let i = 0; i < rows.length; i++) {
        const row = [];
        // Capture both standard data cells (td) and header cells (th)
        const cols = rows[i].querySelectorAll('td, th');

        for (let j = 0; j < cols.length; j++) {
            // Clean text data and escape double quotes to avoid breaking format
            let data = cols[j].innerText.replace(/"/g, '""');
            row.push(`"${data}"`);
        }
        csvData.push(row.join(','));
    }

    // Combine rows with a newline delimiter
    const csvString = csvData.join('\n');

    // Create a download link and trigger the browser to download the file
    const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export default class SubmissionResults extends Component {
    constructor(props) {
        super(props);

        let start_date = new Date();
        while (start_date.getDay() < 6) {
            start_date.setDate(start_date.getDate() - 1);
        }
        start_date.setDate(start_date.getDate() - 21);
        start_date = format_date(start_date, 'mm/dd/yyyy');

        let end_date = new Date(start_date);
        end_date.setDate(end_date.getDate() + 27);
        end_date = format_date(end_date, 'mm/dd/yyyy');

        this.state = {
            results_by_day: false,
            processes_loaded: false,
            submissions_loaded: false,
            processes: {},
            submissions: [],
            start_date: start_date,
            end_date: end_date,
            process: null,
            height: 0,
        };

        this.top_ref = React.createRef();
    }

    componentDidMount() {
        ajaxWrapper('GET', `/process_search_terms/`, {}, (value) =>
            this.setState({ processes: value, processes_loaded: true }),
        );

        this.refresh_submissions();
    }

    refresh_submissions = (state, callback) => {
        if (typeof state == 'undefined') {
            state = {};
        }
        state['submissions'] = {};
        state['submissions_loaded'] = false;
        if (this.top_ref.current) {
            state['height'] =
                window.innerHeight -
                70 -
                this.top_ref.current.offsetHeight -
                40;
        }

        this.setState(
            state,
            function () {
                let start = this.state.start_date;
                let end = this.state.end_date;
                let process = this.state.process;

                ajaxWrapper(
                    'GET',
                    `/submission_results/?start_date=${start}&end_date=${end}&process=${process ? encodeURIComponent(process) : ''}`,
                    {},
                    (value) =>
                        this.setState(
                            { submissions: value, submissions_loaded: true },
                            function () {
                                if (callback) {
                                    callback();
                                }
                            }.bind(this),
                        ),
                );
            }.bind(this),
        );
    };

    render() {
        let process_options = [];
        let process_names = Object.keys(this.state.processes);
        process_names.sort();

        for (let key of process_names) {
            process_options.push({
                text: key,
                value: key,
            });
        }

        let date_headers,
            empty_cells = [];
        if (this.state.results_by_day) {
            [date_headers, empty_cells] = get_headers_by_day(this.state);
        } else {
            [date_headers, empty_cells] = get_headers_by_week(this.state);
        }

        let submission_table = null;
        if ('error' in this.state.submissions) {
            submission_table = (
                <Alert type="warning">{this.state.submissions['error']}</Alert>
            );
        } else {
            let result_jsx = [];

            for (let key of process_names) {
                let process_total = 0;
                let process_total_by_weeks = [];
                for (let i of date_headers) {
                    process_total_by_weeks.push(0);
                }
                let search_value_jsx = [];

                if (!(key in this.state.submissions)) {
                    continue;
                }

                for (let search_value of this.state.processes[key]) {
                    let total_submissions = 0;
                    let total_by_weeks = [];
                    let attempted_required = parseInt(search_value['req']);

                    let cells = [];
                    if (this.state.results_by_day) {
                        [cells, total_submissions] =
                            get_submission_cells_by_day(
                                this.state,
                                key,
                                search_value,
                            );
                    } else {
                        [cells, total_by_weeks] = get_submission_cells_by_week(
                            this.state,
                            key,
                            search_value,
                        );

                        total_submissions = total_by_weeks.reduce(
                            (accumulator, currentValue) =>
                                accumulator + currentValue,
                            0,
                        );

                        for (let i in total_by_weeks) {
                            process_total_by_weeks[i] += total_by_weeks[i];
                        }
                    }

                    let required_color = '';
                    if (isNaN(attempted_required) || attempted_required == 0) {
                        required_color = '';
                    } else if (!total_submissions) {
                        required_color = 'danger';
                    } else if (attempted_required > total_submissions) {
                        required_color = 'warning';
                    } else if (total_submissions >= attempted_required) {
                        required_color = 'success';
                    }

                    search_value_jsx.push(
                        <tr>
                            <td
                                className="sticky-col"
                                style={{
                                    maxWidth: '300px',
                                    overflow: 'hidden',
                                }}
                                title={search_value['name']}
                            >
                                <div
                                    style={{
                                        fontSize: '12px',
                                        paddingLeft: '8px',
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    {search_value['name']}
                                </div>
                            </td>
                            <td
                                style={{
                                    textAlign: 'center',
                                    fontSize: '12px',
                                }}
                            >
                                {search_value['req']}
                            </td>
                            <td
                                className={required_color}
                                style={{ textAlign: 'center' }}
                            >
                                {total_submissions}
                            </td>
                            {cells}
                        </tr>,
                    );

                    process_total += total_submissions;
                }

                result_jsx.push(
                    <tr>
                        <th className="sticky-col">
                            <b>{key}</b>
                        </th>
                        <th></th>
                        <th></th>
                        {empty_cells}
                    </tr>,
                );

                result_jsx.push(...search_value_jsx);

                let sub_totals = [];
                if (this.state.results_by_day) {
                    sub_totals = empty_cells;
                } else {
                    sub_totals = [];
                    for (let subtotal of process_total_by_weeks) {
                        sub_totals.push(
                            <td
                                style={{
                                    textAlign: 'center',
                                    backgroundColor: '#f2fbff',
                                    borderColor: '#bce8f1',
                                }}
                            >
                                {subtotal}
                            </td>,
                        );
                    }
                }

                result_jsx.push(
                    <tr>
                        <td
                            className="sticky-col"
                            style={{
                                fontSize: '12px',
                                backgroundColor: '#f2fbff',
                                borderColor: '#bce8f1',
                            }}
                        >
                            Totals
                        </td>
                        <td
                            style={{
                                backgroundColor: '#f2fbff',
                                borderColor: '#bce8f1',
                            }}
                        ></td>
                        <td
                            style={{
                                textAlign: 'center',
                                backgroundColor: '#f2fbff',
                                borderColor: '#bce8f1',
                            }}
                        >
                            {process_total}
                        </td>
                        {sub_totals}
                    </tr>,
                );
            }

            if (result_jsx.length == 0) {
                submission_table = (
                    <Alert type="warning">
                        {
                            'No Submissions found for your filters.  Please choose a different process or a wider date range.'
                        }
                    </Alert>
                );
            } else {
                submission_table = (
                    <table
                        id="table-to-download"
                        className="fancy-table"
                        style={{ minWidth: '100%' }}
                    >
                        <tr>
                            <StickyCorner></StickyCorner>
                            <th className="sticky-row">
                                <div
                                    style={{
                                        padding: '0px 4px',
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    {'Required'}
                                </div>
                            </th>
                            <th className="sticky-row">
                                <div
                                    style={{
                                        padding: '0px 4px',
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    {"QC's Done"}
                                </div>
                            </th>
                            {date_headers}
                        </tr>
                        {result_jsx}
                    </table>
                );
            }
        }

        let defaults = {
            start_date: this.state.start_date,
            end_date: this.state.end_date,
        };

        return (
            <div className="simple-page-wrapper">
                <Navbar
                    style={{
                        position: 'fixed',
                        width: '100%',
                        zIndex: '10',
                        top: '0px',
                    }}
                />

                <Container style={{ background: 'white' }} min_height={true}>
                    <div
                        className="row"
                        style={{ position: 'relative', paddingTop: '15px' }}
                        ref={this.top_ref}
                    >
                        <div className="transitions col-4">
                            <div
                                style={{
                                    float: 'right',
                                    marginTop: '35px',
                                }}
                            >
                                <Button
                                    type="info"
                                    text={
                                        this.state.results_by_day
                                            ? 'Show By Week'
                                            : 'Show By Day'
                                    }
                                    onClick={
                                        this.state.results_by_day
                                            ? () =>
                                                  this.setState({
                                                      results_by_day: false,
                                                  })
                                            : () =>
                                                  this.setState({
                                                      results_by_day: true,
                                                  })
                                    }
                                />
                                <br />
                                <Button
                                    style={{ margin: '10px 0px' }}
                                    type="info"
                                    text={'Download'}
                                    onClick={() =>
                                        downloadHTMLTableAsCSV(
                                            'table-to-download',
                                        )
                                    }
                                />
                            </div>

                            <Header size={1} text={'QC Report'} />
                        </div>
                        <div className="transitions col-8">
                            <div style={{ marginTop: '10px' }}>
                                <FormWithChildren
                                    globalStateName="result_filters"
                                    submit={this.refresh_submissions}
                                    className={'row'}
                                    defaults={defaults}
                                    submit_text={'Update'}
                                    submitClassName={'label-margin-top'}
                                    submit_wrapper_class={'col-lg-3'}
                                >
                                    <Select
                                        label={'Process'}
                                        className={'col-lg-3'}
                                        options={process_options}
                                        name={'process'}
                                    />
                                    <DateTimePicker
                                        label="Start Date"
                                        className={'col-lg-3'}
                                        name={'start_date'}
                                        display_time={false}
                                        by_week={!this.state.results_by_day}
                                        weekday={6}
                                    />
                                    <DateTimePicker
                                        label="End Date"
                                        className={'col-lg-3'}
                                        name={'end_date'}
                                        display_time={false}
                                        by_week={!this.state.results_by_day}
                                        weekday={5}
                                    />
                                    ,
                                </FormWithChildren>
                            </div>
                        </div>
                    </div>
                    <div className="simple-card-container">
                        <div className="simple-card">
                            <div
                                style={{
                                    overflow: 'auto',
                                    width: '100%',
                                    maxHeight: `${this.state.height}px`,
                                    minHeight: '200px',
                                    position: 'relative',
                                }}
                            >
                                <Loading
                                    loaded={
                                        this.state.processes_loaded &&
                                        this.state.submissions_loaded
                                    }
                                >
                                    {submission_table}
                                </Loading>
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
        );
    }
}
